"use client";

import { createContext, useContext, useState } from "react";

interface ActivePlayerContextType {
  activePlayer: null | string;
  setActivePlayer: React.Dispatch<React.SetStateAction<null | string>>;
}

const ActivePlayerContext = createContext<ActivePlayerContextType | undefined>(undefined);

export const ActivePlayerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activePlayer, setActivePlayer] = useState<null | string>(null);

  return (
    <ActivePlayerContext.Provider value={{ activePlayer, setActivePlayer }}>{children}</ActivePlayerContext.Provider>
  );
};

export const useActivePlayer = () => {
  const context = useContext(ActivePlayerContext);
  if (context === undefined) {
    throw new Error("useActivePlayer must be used within an ActivePlayerProvider");
  }
  return context;
};
